import { Box, ColorOptions, convertHexToRGBA, Spacer, Text } from '@jfs/ui-new'
import { Colors, convertWordCapitalize, dateFormatter, DateFormatTypes } from '../../../util/util'
import { SvgImage } from '../../SvgImage'
import { styles } from './styles'

interface ListRowProps {
  item: any
  index: number
  sizeConfig?: Array<number>
  disabled: boolean
  onPress: () => void
  onExport?: any
  isReportDownloading?: boolean
  selectedIdForDownload?: any
}

const colorMap = {
  success: 'GREEN',
  failed: 'ERROR',
  failure: 'ERROR',
  inprocess: 'ORANGE',
  awaited: 'ORANGE',
  ['refund failed']: 'ERROR',
  //['refund accepted']: 'GREEN', // TODO: As per diss with mangment team, removing the color code for refund accepted
  none: 'BLACK',
}

const getColor = (item: any) => {
  return colorMap[(item as keyof typeof colorMap) || 'none']
}

const ListItemRefunds = ({ item, onPress, disabled, ...props }: ListRowProps) => {
  const width = props?.width - 130
  let customerName = convertWordCapitalize(item?.customerName)
  const fontSize = 12
  const division = width / fontSize

  const getDateAndMop = (maxLength?: any) => {
    const paymentMode = item.paymentMode
    const dateObj = dateFormatter(item?.date, DateFormatTypes.DD_MMM_TIME)
    const dotAndMode = paymentMode?.length > maxLength ? paymentMode?.slice(0, maxLength) + '...' : paymentMode
    return `${dateObj}, ${dotAndMode}`
  }

  return (
    <Box {...styles.container} disabled={disabled} testID={'ListItemRefunds-' + props?.index} onPress={onPress}>
      <Box flexGrow={1}>
        <Text
          numberOfLines={1}
          fontFamily={'JioType-Medium'}
          fontSize={14}
          lineHeight={20}
          letterSpacing={-0.07}
          color={Colors.BLACK_14 as ColorOptions}>
          {customerName?.length > division ? customerName?.slice(0, division) + '...' : customerName}
        </Text>
        <Text
          color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
          numberOfLines={1}
          fontFamily={'JioType-Medium'}
          fontSize={12}
          lineHeight={16}
          letterSpacing={-0.06}>
          {getDateAndMop(division - 5)}
        </Text>
      </Box>
      <Spacer direction={'horizontal'} size={4} />
      <Box>
        <Text
          textAlign="right"
          fontFamily={'JioType-Bold'}
          fontSize={14}
          lineHeight={20}
          letterSpacing={-0.06}
          color={Colors.BLACK_14 as ColorOptions}>
          {item.refundAmount}
        </Text>
        <UIText type={item?.refundStatus?.toLowerCase()} />
      </Box>
    </Box>
  )
}
const ListItemSettlement = ({
  item,
  onPress,
  disabled,
  onExport,
  isReportDownloading,
  selectedIdForDownload,
  index,
}: ListRowProps) => {
  return (
    <Box {...styles.container} disabled={disabled} testID={'ListItemSettlement-' + index} onPress={onPress}>
      <Box
        w={40}
        h={40}
        borderRadius={20}
        bg={convertHexToRGBA(Colors.SECONDARY, 8) as ColorOptions}
        justify={'center'}
        align={'center'}>
        <SvgImage color={Colors.SECONDARY} imageName="calender" />
      </Box>
      <Box flexGrow={1} pl={16}>
        <Text
          numberOfLines={1}
          fontFamily={'JioType-Medium'}
          fontSize={14}
          lineHeight={20}
          letterSpacing={-0.07}
          color={Colors.BLACK_14 as ColorOptions}>
          {dateFormatter(item?.date, DateFormatTypes.DD_MMM_WEEK) ?? 'NA'}
        </Text>
        <Text
          color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
          numberOfLines={1}
          fontFamily={'JioType-Medium'}
          fontSize={12}
          lineHeight={16}
          letterSpacing={-0.06}>
          {'Settled'}
        </Text>
      </Box>
      <Spacer direction={'horizontal'} size={4} />
      <Box>
        <Text numberOfLines={1} textAlign="right" fontFamily={'JioType-Bold'} fontSize={14} lineHeight={20}>
          {item?.settledAmount ? `+ ${item?.settledAmount}` : 'NA'}
        </Text>
      </Box>
    </Box>
  )
}

const ListItemTxn = ({ item, onPress, disabled, index, ...props }: ListRowProps) => {
  const width = props?.width - 100
  let customerName = convertWordCapitalize(item?.customerName)
  const fontSize = 12
  let division = width / fontSize

  const getDateAndMop = () => {
    const dateObj = dateFormatter(item?.date, DateFormatTypes.DD_MMM_TIME)
    return `${dateObj}, ${item.paymentMode?.slice(0, 24)}`
  }

  return (
    <Box {...styles.container} disabled={disabled} onPress={onPress} testID={`listItemTxn${index}`}>
      <Box flexGrow={1}>
        <Text
          numberOfLines={1}
          fontFamily={'JioType-Medium'}
          fontSize={14}
          lineHeight={20}
          letterSpacing={-0.07}
          color={Colors.BLACK_14 as ColorOptions}>
          {customerName?.length > division ? customerName?.slice(0, division) + '...' : customerName}
        </Text>
        <Text
          color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
          numberOfLines={1}
          fontFamily={'JioType-Medium'}
          fontSize={12}
          lineHeight={16}
          letterSpacing={-0.06}>
          {getDateAndMop()}
        </Text>
      </Box>
      <Spacer direction={'horizontal'} size={8} />
      <Box>
        <Text
          textAlign="right"
          fontFamily={'JioType-Bold'}
          fontSize={14}
          lineHeight={20}
          letterSpacing={-0.06}
          color={Colors.BLACK_14 as ColorOptions}>
          {item?.transactionStatus?.toLowerCase() === 'success' ? '+ ' + item.totalAmount : item.totalAmount}
        </Text>
        <UIText type={item?.transactionStatus?.toLowerCase()} />
      </Box>
    </Box>
  )
}

const UIText = ({ type }: any) => {
  return (
    <Text
      color={getColor(type) as ColorOptions}
      numberOfLines={1}
      fontFamily={'JioType-Medium'}
      fontSize={12}
      lineHeight={16}
      letterSpacing={-0.06}
      textAlign="right">
      {type !== 'success' ? type?.toUpperCase() : ''}
    </Text>
  )
}

export { ListItemSettlement, ListItemTxn, ListItemRefunds }
